import React, { useState } from 'react';
import { Form, Card, Space, DatePicker } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
// import localStyles from './index.module.less';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import Layout from '@/common/Layout';
import { history } from 'app/history';
import { useGetVacuumCleaningListQuery } from '../../redux/apiSlice';
import moment from 'moment';
import Spinner from '../../../../common/Spinner';
import { EditOutlined } from '@ant-design/icons';
const { RangePicker } = DatePicker;

const AdminPage = () => {
  const [form] = Form.useForm();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  let totalRecords;

  const { data, error, isLoading, refetch } = useGetVacuumCleaningListQuery({
    page,
    per_page: perPage,
    from_date: fromDate,
    to_date: toDate
  });

  console.log('data ====', data);

  const columns = [
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        return record?.location_area_master?.location
          ? record.location_area_master.location
          : '';
      }
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        return record?.cleaning_of_vaccum_cleaner_id_no_master?.id_no
          ? record.cleaning_of_vaccum_cleaner_id_no_master.id_no
          : '';
      }
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        return record?.date ? moment(record?.date).format('DD-MMM-YYYY') : '';
      }
    },
    {
      title: 'Start time',
      dataIndex: 'cleaning_start_time',
      key: 'cleaning_start_time',
      ellipsis: true
      // width: '200px',
    },
    {
      title: 'End time',
      dataIndex: 'cleaning_end_time',
      key: 'cleaning_end_time',
      ellipsis: true
    },
    {
      title: 'Filter bag / Filter status',
      dataIndex: 'filter_status',
      key: 'filter_status',
      ellipsis: true
      // width: '200px',
    },
    {
      title: 'Cleaned by (User id & Date)',
      dataIndex: 'cleaned_by',
      key: 'cleaned_by',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        let result = '';
        record?.cleaned_by_user_id ? (result = record.cleaned_by_user_id) : '';
        record?.cleaned_by_user_date
          ? (result += ` (${moment(record?.cleaned_by_user_date).format(
              'DD-MMM-YYYY'
            )})`)
          : '';
        return result;
      }
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
      ellipsis: true
      // width: '200px',
    },
    {
      title: 'Action',
      dataIndex: 'received_by',
      key: 'received_by',
      align: 'center',
      width: '150px',
      // ellipsis: true,
      //sorter: (a, b) => a?.po_number?.localeCompare(b?.po_number),
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => (
        <EditOutlined
          onClick={() =>
            history.push(`/log-books-vacuum-cleaner-create?id=${record?.id}`)
          }
        />
      )
    }
  ];

  let content;
  if (isLoading) {
    console.log('Loading.....');
    content = <Spinner />;
  } else if (data) {
    console.log(data?.pagination?.total_records);
    totalRecords = data?.pagination?.total_records;
    content = (
      <Layout sider={false}>
        {/* <div className={localStyles.heading1}>
          <h1>Overview</h1>
          <h4>Your current requests summary and other activities</h4>
        </div> */}
        <Form form={form} layout="vertical">
          <Card
            title={<span>Cleaning records of Vaccum cleaner</span>}
            className={`${styles.cardStyles_approver}`}
            extra={
              <Space>
                <RangePicker
                  onChange={(e) => {
                    console.log(e[0]._d);
                    setFromDate(moment(e[0]._d).startOf('day').format());
                    setToDate(moment(e[1]._d).endOf('day').format());
                  }}
                />
                <CustomButton
                  className={styles.inwardButton}
                  onClick={() =>
                    history.push('/log-books-vacuum-cleaner-create')
                  }
                  type="primary"
                >
                  Create
                </CustomButton>
              </Space>
            }
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                columns={columns}
                dataSource={data.data}
                pagination={{
                  size: 'small',
                  pageSize: perPage,
                  defaultCurrentPage: page,
                  total: totalRecords,
                  onChange: (page, pageSize) => {
                    setPage(page);
                    setPerPage(pageSize);
                    refetch();
                  },
                  showSizeChanger: true
                }}
              />
            </div>
          </Card>
          <br />
          <FormItem className="text-center">
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.push('log-books')}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </FormItem>
        </Form>
      </Layout>
    );
  } else if (error) {
    console.log(error);
    content = 'Something went wrong!';
  }

  return <>{content}</>;
};
export default AdminPage;
